import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import ExperienceBentoTile from './ExperienceBentoTile';

const Grid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 50vh;

  @media (min-width: 640px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
`;

const tileVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.05, duration: 0.3 }
  })
};

function BentoGrid({ experiences, onExperienceClick, showSaveButton, isSaved, onSaveClick }) {
  return (
    <Grid>
      {experiences.map((exp, i) => (
        <ExperienceBentoTile
          key={exp.id}
          experience={exp}
          index={i}
          variants={tileVariants}
          onExperienceClick={onExperienceClick}
          showSaveButton={showSaveButton}
          isSaved={isSaved?.(exp.id)}
          onSaveClick={onSaveClick}
        />
      ))}
    </Grid>
  );
}

export default BentoGrid;
